import { Route } from '@angular/router'

import { AuthGuard } from '../../abacus/guards/auth.guard'
import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { TransparencyProfileGuard } from '../../abacus/guards/transparency-profile.guard'

import { TransparencyReportListComponent } from './transparency-report-list/transparency-report-list.component'
import { TransparencyReportSubmitComponent } from './transparency-report-submit/transparency-report-submit.component'
import { TransparencyReportDetailComponent } from './transparency-report-detail/transparency-report-detail.component'

export const transparencyReportRoutes: Route[] = [
  {
    path: 'transparency-reports',
    component: TransparencyReportListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTransparencyReports'
    }
  },
  {
    path: 'transparency-reports/submit',
    component: TransparencyReportSubmitComponent,
    canActivate: [AuthGuard, PermissionGuard, TransparencyProfileGuard],
    data: {
      permission: 'submitTransparencyReports'
    }
  },
  {
    path: 'transparency-reports/:id',
    component: TransparencyReportDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['readTransparencyReports', 'readOwnTransparencyReports']
    }
  }
]
